const toTZS = (n) => {
  try {
    return n.toLocaleString() + " TZS";
  } catch (e) {
    return "";
  }
};

export { toTZS };
